import Title from 'components/layout/Title';

export default function NotFound() {
  return (
    <Title className='text-center'>404 not found</Title>
  );
}
